export default {
    url: '/list',
    template: '<forms-settings-meta-list></forms-settings-meta-list>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/settings/meta/list/index.js